import React, { useEffect, useState } from "react";
import { getTopper } from "../Service/Api";
import { Link } from 'react-router-dom'
import LazyLoad from "react-lazyload";

const TopperX = () => {
   const [data, setData] = useState([]);
   const [filterData, setFilteredData] = useState([]);
   const [selectedYear, setSelectedYear] = useState("");
   const [yearRanges, setYearRanges] = useState([]);
   const [searchQuery, setSearchQuery] = useState("");

   useEffect(() => {
      const currentYear = new Date().getFullYear();
      const Year = `${currentYear - 1}-${currentYear}`;
      setSelectedYear(Year);
   }, []);

   useEffect(() => {
      const fetchData = async () => {
         const galleryData1 = await getTopper();
         const galleryData = galleryData1.filter((item) => item.class === 'X');
         setData(galleryData);

         // Extract unique years
         const uniqueYears = Array.from(
            new Set(galleryData.map((item) => item.sessionYear))
         );

         setYearRanges(uniqueYears);
         setFilteredData(galleryData); // Initialize filteredData with all data
      };
      fetchData();
   }, []);

   useEffect(() => {
      // Filter data based on selected year and search query
      let filteredData = data;
      if (selectedYear !== "All") {
         filteredData = filteredData.filter((item) => item.sessionYear === selectedYear);
      }
      if (searchQuery) {
         filteredData = filteredData.filter((item) =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
         );
      }

      // Sort data by division in descending order
      filteredData.sort((a, b) => parseFloat(b.division) - parseFloat(a.division));

      setFilteredData(filteredData);
   }, [selectedYear, searchQuery, data]);

   return (
      <>
         <div className="breadcrumb">
            <h2>Topper X</h2>
            <ul>
               <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
               <li>|</li>
               <li>Topper X</li>
            </ul>
         </div>

         <div className="inner_page">

            <div className="container">
               <div className="row tabs-dynamic">
                  <div className="col-md-6">
                     <div className="month-selection">
                        <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} className="yearSelection">
                           <option value={"All"}>All</option>
                           {yearRanges.map((yr) => (
                              <option key={yr} value={yr}>{yr}</option>
                           ))}
                        </select>
                     </div>
                  </div>
                  <div className="col-md-6">
                     <div className="searchBox">
                        <input type="text" id="myInput" name="name" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} placeholder="Search Here.." />
                     </div>
                  </div>
               </div>
               <div className="row">
                  {filterData.length > 0 ? (
                     filterData.map((item, index) => (
                        <div className="col-md-3" key={index}>
                           <div className="topperdiv">
                              <div className="toppertaj">
                                 <LazyLoad><img src={item.attachments && item.attachments[0] ? `https://webapi.entab.info/api/image/${item.attachments[0]}` : "https://webapi.entab.info/api/image/SFSAP/public/Images/birthday2.jpg"} className="img-fluid" alt="St francis school, Amritsar" /></LazyLoad>
                              </div>
                              <div className="topperdesc">
                                 <p className="name">{item.name}<span>{item.stream}</span></p>
                                 <p className="per">{item.division}</p>
                              </div>
                           </div>
                        </div>
                     ))) : (
                     <div className="col-md-3">
                        <div className="topperdiv">
                           <div className="toppertaj">
                              <LazyLoad><img src= "https://webapi.entab.info/api/image/SFSAP/public/Images/birthday2.jpg" className="img-fluid" /></LazyLoad>
                           </div>
                           <div className="topperdesc">
                              <p className="name">Student Name<span>Stream</span></p>
                              <p className="per">100%</p>
                           </div>
                        </div>
                     </div>
                  )}

               </div>
            </div>
         </div>
      </>
   );
};

export default TopperX;
